module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    attrs: {
      "title": "",
      "type": "info",
      "closable": false
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('v-table', {
    attrs: {
      "page-size": 0,
      "table-minheight": 200,
      "table-data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "编码",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.editable) ? _c('el-input', {
          attrs: {
            "placeholder": "字母、数字、下划线"
          },
          model: {
            value: (row.code),
            callback: function($$v) {
              _vm.$set(row, "code", $$v)
            },
            expression: "row.code"
          }
        }) : _c('span', [_vm._v(_vm._s(row.code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.editable) ? _c('el-input', {
          attrs: {
            "placeholder": "请输入名称"
          },
          model: {
            value: (row.name),
            callback: function($$v) {
              _vm.$set(row, "name", $$v)
            },
            expression: "row.name"
          }
        }) : _c('span', [_vm._v(_vm._s(row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.editable) ? _c('el-select', {
          model: {
            value: (row.type),
            callback: function($$v) {
              _vm.$set(row, "type", $$v)
            },
            expression: "row.type"
          }
        }, _vm._l((_vm.$dict.store.PARK_CHANNELTYPE), function(item) {
          return _c('el-option', {
            key: item[0],
            attrs: {
              "value": item[0],
              "label": item[1]
            }
          })
        }), 1) : _c('span', [_vm._v(_vm._s(_vm.$dict.getText(row.type, _vm.$dict.store.PARK_CHANNELTYPE)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.editable) ? _c('el-input', {
          attrs: {
            "placeholder": "备注"
          },
          model: {
            value: (row.remark),
            callback: function($$v) {
              _vm.$set(row, "remark", $$v)
            },
            expression: "row.remark"
          }
        }) : _c('span', [_vm._v(_vm._s(row.remark))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "title": "扫码支付二维码"
          },
          on: {
            "click": function($event) {
              return _vm.flushQrCode(scope.row)
            }
          }
        }, [_c('icon', {
          attrs: {
            "name": "qrcode"
          }
        })], 1), _vm._v(" "), (scope.row.editable) ? _c('el-button', {
          attrs: {
            "type": "text",
            "title": "保存"
          },
          on: {
            "click": function($event) {
              return _vm.save(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        })]) : _c('el-button', {
          attrs: {
            "type": "text",
            "title": "编辑"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "title": "删除"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.row, scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete red"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    ref: "qrDiag",
    attrs: {
      "title": "通道二维码",
      "width": "600px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "链接",
      "type": "warning",
      "description": _vm.qrCode.content,
      "closable": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.qrCode.imgUrl
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cae9ef9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/parkInfo/Channel.vue
// module id = 349
// module chunks = 0